module.exports = __webpack_public_path__ + "img/background.c485da99.jpg";